<template>
  <div>
    <v-container>
      <v-row justify="start">
        <v-col cols="12" md="2">
          <v-sheet width="300" class="mx-auto">
            <v-form fast-fail @submit.prevent>
              <v-select
                v-model="select"
                :hint="`${select.state}, ${select.abbr}`"
                :items="items"
                item-title="state"
                item-value="abbr"
                label="Select"
                persistent-hint
                return-object
                single-line
              ></v-select>
              <v-select
                v-model="select"
                :hint="`${select.state}, ${select.abbr}`"
                :items="items"
                item-title="state"
                item-value="abbr"
                label="Select"
                persistent-hint
                return-object
                single-line
              ></v-select>

              <v-btn type="submit" block class="mt-2">Submit</v-btn>
            </v-form>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <div class="mx-5 my-5">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            color="light-blue-darken-4"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="registros" :search="search">
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small @click="abrirDialogo(item)"> Ver Certificado </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { VDataTable, VBtn } from 'vuetify/labs/VDataTable'
export default defineComponent({
    name: 'AdminPage',
    components: {
        VDataTable,
        VBtn,
    },
    data() {
        var registros;
        return {
            registros,
            search: '',
            headers: [
                { key: 'name', align: 'center', sortable: true },
                { key: 'cod_personal', title: 'Codigo Personal' },
                { key: 'carnet', title: 'Cedula Identidad' },
                { key: 'nombres', title: 'Nombres' },
                { key: 'apellido_paterno', title: 'Apellido Paterno' },
                { key: 'apellido_materno', title: 'Apellido Materno' },
                { key: 'actions', title: 'Acciones', align: 'center' },
            ],
            select: { state: "Florida", abbr: "FL" },
            items: [
                { state: "Florida", abbr: "FL" },
                { state: "Georgia", abbr: "GA" },
                { state: "Nebraska", abbr: "NE" },
                { state: "California", abbr: "CA" },
                { state: "New York", abbr: "NY" },
            ],
            datos: [
                {
                    name: 'African Elephant',
                    species: 'Loxodonta africana',
                    diet: 'Herbivore',
                    habitat: 'Savanna, Forests',
                },
                // ... more items
            ],
        }
    }
});
</script>
